"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var stringifyLD = function (options) {
    return function stringifyLDFn() {
        var _a;
        var jsonLd = this.$options.jsonld.call(this);
        if (jsonLd === null) {
            return {};
        }
        var stringifiedJson = JSON.stringify(jsonLd, null, options.space);
        var innerHTML = options.space === 0 ? stringifiedJson : "\n" + stringifiedJson + "\n";
        // FIXME: private api
        var hid = "nuxt-jsonld-" + this._uid;
        return {
            script: [
                {
                    hid: hid,
                    type: 'application/ld+json',
                    innerHTML: innerHTML,
                },
            ],
            __dangerouslyDisableSanitizersByTagID: (_a = {},
                _a[hid] = ['innerHTML'],
                _a),
        };
    };
};
function default_1(pluginOpts) {
    var _this = this;
    if (!this.$options) {
        return function () { };
    }
    this.$options.computed = this.$options.computed || {};
    this.$options.computed.$jsonld = stringifyLD(pluginOpts);
    if (this.$options.head) {
        if (typeof this.$options.head === 'function') {
            this.$options.computed.$head = this.$options.head;
        }
        else {
            this.$head = this.$options.head;
        }
    }
    return function () { return (__assign(__assign({}, _this.$head), _this.$jsonld)); };
}
exports.default = default_1;
